import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59aca886"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-with-text" }


  import { useRoute, useRouter } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Table',
  props: ['value'],
  setup(__props) {

  const router = useRouter();
  const redirect = (path: string) => {
    router.push(path);
  }
  const table = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.value, (t) => {
    return (_openBlock(), _createElementBlock("div", null, [
      _createElementVNode("h5", _hoisted_1, [
        _createVNode(_component_el_divider, {
          class: "divider",
          "border-style": "double"
        }),
        _createTextVNode(" " + _toDisplayString(t.title) + " ", 1),
        _createVNode(_component_el_divider, {
          class: "divider",
          "border-style": "double"
        })
      ]),
      _createVNode(_component_el_table, {
        data: t.data,
        stripe: "",
        border: "",
        style: _normalizeStyle([{ boxShadow: `var(--el-box-shadow-lighter)`}, {"width":"100%","font-family":"Lato, sans-serif","font-weight":"400","color":"#232946"}]),
        "max-height": "250"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "code",
            label: "Code",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name",
            width: "840"
          }),
          _createVNode(_component_el_table_column, {
            prop: "usage",
            label: "Usage"
          }),
          (t.isUnit)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                fixed: "right",
                prop: "essential",
                label: "Essential"
              }))
            : (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                fixed: "right",
                label: "Operations"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    style: {"text-decoration":"underline","color":"#232946"},
                    link: "",
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (redirect(`/course-detail/${scope.row.id}`))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Detail")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }))
        ]),
        _: 2
      }, 1032, ["data", "style"])
    ]))
  }), 256))
}
}

})